/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Commonbtnretry2Inputs */



/**
* | output |
* | --- |
* | "Retry" |
*
* @param {Commonbtnretry2Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const commonbtnretry2 = /** @type {((inputs?: Commonbtnretry2Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Commonbtnretry2Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Retry")
	if (locale === "es") return /** @type {LocalizedString} */ ("Reintentar")
	return /** @type {LocalizedString} */ ("Попробовать ещё раз")
});
export { commonbtnretry2 as "commonBtnRetry" }